// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"581":"grab","594":"about"}[chunkId] + "." + {"581":"2f62c8e2","594":"8f651508"}[chunkId] + ".js";
};